export function canImportPackageV3(isSuperAdmin, isOrganizationAdmin) {
  return !!(isSuperAdmin || isOrganizationAdmin);
}
